const styles = theme => ({
  dialogContent: {
    display: "flex",
    alignItems: "center",
    padding: 40,
  },
  dialogTitle: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.primary.dark,
  },
  textField: {
    maxWidth: 100,
    margin: 20,
  },
  percentage: {
    width: 50,
    margin: 20,
  },
  closeButton: {
    color: "#fff",
  },
})

export default styles
